import { render, staticRenderFns } from "./btnConfirmUser.vue?vue&type=template&id=04823991&scoped=true&"
import script from "./btnConfirmUser.vue?vue&type=script&lang=js&"
export * from "./btnConfirmUser.vue?vue&type=script&lang=js&"
import style0 from "./btnConfirmUser.vue?vue&type=style&index=0&id=04823991&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04823991",
  null
  
)

export default component.exports